import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgMealBuilderItemSelectorCardQuantityButton',
})
export default class CmgMealBuilderItemSelectorCardQuantityButton extends Vue {
  @Prop({ required: true, type: String })
  kind!: 'minus' | 'plus';

  get buttonImageUrl(): string {
    const icons = this.$appStore.state.cms.images.icons;
    return this.kind == 'plus' ? icons.circlePlus.default : icons.circleMinus.default;
  }
}
